import React, { useEffect, useState } from 'react';
import {
  Alert,
  Button,
  ButtonToolbar,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import { FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import {
  CANCEL_BONIFIED_INVOICE,
  CANCEL_DEFINITIVE,
  CANCEL_NEW_INOVICE,
} from '../../../../shared/utils/constants';
import { accountListByFilterObject } from '../../../../shared/queries/Account';
import GraphQL from '../../../../GraphQL';

const InvoiceCancelOptions = ({ t, isOpen, toggle, onConfirm }) => {
  const [hasDefaultAccount, setHasDefaultAccount] = useState(null);

  const [typeCancel, setCancel] = useState(CANCEL_DEFINITIVE);

  const onChangeFinancial = (type) => {
    if (type) {
      setCancel(type);
    }
  };

  const loadDefaultAccount = () => {
    const filter = {
      filterByStatus: true,
      active: true,
      defaultAccount: true,
      smartpay: false,
    };
    const query = accountListByFilterObject(filter);
    GraphQL(query, {})
      .then((res) => {
        setHasDefaultAccount(res.accountListByFilter.length > 0);
      })
      .catch((error) => {
        console.error(error);
        setHasDefaultAccount(false);
      });
  };

  useEffect(() => {
    loadDefaultAccount();
  }, []);

  return (
    <div>
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        className="theme-light"
        backdrop="static"
      >
        <ModalHeader>{t('general.cancel-options')}</ModalHeader>
        <ModalBody className="modal__body">
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.smartpay-billet')}
            </span>
            <div className="form__form-group-field">
              <RadioGroup
                name="type"
                defaultValue={CANCEL_DEFINITIVE}
                onChange={(evt) => {
                  onChangeFinancial(evt.target.value);
                }}
              >
                <FormControlLabel
                  value={CANCEL_DEFINITIVE}
                  control={<Radio />}
                  label={t(`general.permanently-cancel`)}
                  labelPlacement="end"
                />
                <FormControlLabel
                  value={CANCEL_NEW_INOVICE}
                  disabled={!hasDefaultAccount}
                  control={<Radio />}
                  label={t(`general.generate-new-financial`)}
                  labelPlacement="end"
                />
                <FormControlLabel
                  value={CANCEL_BONIFIED_INVOICE}
                  disabled={!hasDefaultAccount}
                  control={<Radio />}
                  label={t(`general.download-bonus`)}
                  labelPlacement="end"
                />
              </RadioGroup>
            </div>
          </div>
          {!hasDefaultAccount ? (
            <Alert color="warning">
              {t('notifications.no-default-account')}
            </Alert>
          ) : null}
        </ModalBody>
        <ModalFooter>
          <ButtonToolbar>
            <Button color="danger" onClick={toggle}>
              {t('general.cancel')}
            </Button>
            <Button
              color="success"
              onClick={() => {
                onConfirm(typeCancel);
              }}
            >
              {t('general.confirm')}
            </Button>
          </ButtonToolbar>
        </ModalFooter>
      </Modal>
    </div>
  );
};

InvoiceCancelOptions.propTypes = {
  t: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};
export default withTranslation('common')(InvoiceCancelOptions);
